import { render, staticRenderFns } from "./AllRoles.vue?vue&type=template&id=0589be79&"
import script from "./AllRoles.vue?vue&type=script&lang=ts&"
export * from "./AllRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports